import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AIS140ApiResLogsComponent } from './ais140-api-res-logs.component';
const routes: Routes = [
  {
    path: 'ais140-api-res-logs',
    data: { name: 'AIS140 Ticket AEPL Response Logs', isTab: false },
    component: AIS140ApiResLogsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AIS140ApiResLogsRoutingModule {}
